import { type PensionRecordTableProps, type TableColumn } from "@/types";
import { DataTable } from "../common/DataTable";
// import { useAuthStore } from "@/stores/authStore";
// import { convertMockEmployeesToEmployees } from "@/services/mockData";
// import { formatNGN } from "@/utils/moneyFormatter";
import { type Employee, EmployeeStatus } from "@/models/responses/employees/employees.response";

// const RECORDS_PER_PAGE = 8;

export const EmployeePensionRecord = ({ data, currentPage, totalPages, onPageChange, showPagination, visibleColumns, onRemove }: PensionRecordTableProps) => {
    console.log(data);
    // Define all available columns
    const allColumns: Record<string, TableColumn<Employee>> = {
        dateOfAppointment: {
            key: 'dateOfAppointment',
            header: 'Date',
            render: (value) => {
                const date = new Date(value as string);
                const monthYear = date.toLocaleDateString('en-US', {
                    month: 'short',
                    year: 'numeric'
                });
                return (
                    <span className="text-medium-dark-grey font-regular">{monthYear}</span>
                );
            }
        },
        fullName: {
            key: 'fullName',
            header: 'Full Name',
            render: (value) => (
                <span className="text-medium-dark-grey font-medium">
                    {String(value ?? "")}
                </span>
            )
        },
        pfa: {
            key: 'pfa',
            header: 'PFA',
            render: (value) => {
                const display =
                    typeof value === "string"
                        ? value
                        : (value && typeof value === "object" && "name" in value
                            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            (value as any).name
                            : "");

                return (
                    <span className="text-medium-dark-grey font-regular">
                        {display || "-"}
                    </span>
                );
            }
        },
        rsaPin: {
            key: 'rsaPin',
            header: 'RSA PIN',
            render: (value) => (
                <span className="text-medium-dark-grey font-regular">
                    {String(value ?? "")}
                </span>
            )
        },
        designation: {
            key: 'designation',
            header: 'Designation',
            render: () => (
                <span className="text-medium-dark-grey font-regular">-</span>
            )
        },
        totalSalary: {
            key: 'totalSalary',
            header: 'Total Salary',
            render: () => (
                <span className="text-medium-dark-grey font-regular">-</span>
            )
        },
        status: {
            key: 'status',
            header: 'Status',
            render: (value) => {
                switch(value){
                    case EmployeeStatus.ACTIVE:
                        return (
                        <div className="flex items-center gap-2">
                            <img src="/assets/icons/solid-check.svg" alt="success" className="w-4 h-4" />
                            <span className="text-primary-button font-medium">Active</span>
                        </div>
                    );
                    case EmployeeStatus.REMOVED_PENDING_APPROVAL:
                        return (
                        <span className="text-dark-brown font-medium">Pending Removal</span>
                    );
                    case EmployeeStatus.QUERIED:
                        return (
                        <span className="text-dark-brown font-medium">Queried</span>
                    );
                    case EmployeeStatus.PENDING_APPROVAL:
                        return (
                        <span className="text-dark-red font-medium">Pending Admin Approval</span>
                    );
                    default:
                        return <span className="text-medium-dark-grey font-medium">{String(value ?? "")}</span>;
                }
                
            }
        },
        remove: {
            key: 'id',
            header: 'Action',
            render: (_value, record) => (
                
                <button
                    onClick={(e) => { e.stopPropagation(); onRemove?.(record); }}
                    className="flex items-center gap-x-1.5 bg-light-red text-dark-red font-clash-display text-sm font-medium px-3 py-1.5 rounded-lg hover:opacity-80 hover:pointer disabled:opacity-50 disabled:cursor-not-allowed transition-opacity"
                    disabled={record.status !== EmployeeStatus.ACTIVE}
                >
                    <img src="/assets/icons/delete.svg" alt="remove" className="w-3.5 h-3.5" />
                    Remove
                </button>
            )
        }
    };

    // Filter columns based on visibleColumns prop, or show all by default
    const pensionRecordColumns: TableColumn<Employee>[] = visibleColumns
        ? visibleColumns.map(col => allColumns[col]).filter(Boolean)
        : Object.values(allColumns);

    return (
        <DataTable
            data={data}
            columns={pensionRecordColumns}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            showPagination={showPagination}
            className="mt-8"
            emptyMessage="No pension records found"
        />
    );
};